import React from "react";

export default  function ProductView() {
    return (
      <div style={{backgroundColor: "#ffffff" }} className="px-28 py-10">
        <h2 style={{ color: "white", marginTop: "24px", fontWeight: "bold" }}>
          Product Details
        </h2>
        
        {/* Product Details */}
        <div style={{ marginTop: "16px" }}>
          <DetailRow label="Product Name" value="iPhone 13" />
          <DetailRow label="Model" value="A2636" />
          <DetailRow label="Variant" value="128GB, Blue" />
          <DetailRow label="Condition" value="New" />
          <DetailRow label="Selling Price" value="$799" />
          <DetailRow label="Sold On" value="2024-01-01" />
          <DetailRow label="Serial Number" value="SN123456" />
          <DetailRow label="Purchase Date" value="2022-01-01" />
          <DetailRow label="Warranty Expiry" value="2023-01-01" />
        </div>
  
        <h3 style={{ marginTop: "24px", textAlign: "center", fontWeight: "bold",color:"black" }}>
          User Details
        </h3>
  
        {/* User Details */}
        <div
          style={{
            marginTop: "16px",
            display: "flex",
            justifyContent: "space-between",
            border: "1px solid #ccc",
            padding: "10px",
          }}
        >
          <img
            src="https://firebasestorage.googleapis.com/v0/b/imagine-bc615.appspot.com/o/customers%2Fimage%2Fscaled_bc77bf8d-1943-4df4-b6b9-7da3be6417de3745737381856680911.jpg?alt=media&token=1eec2036-5033-4aa2-94a3-87fcf6a025c2"
            alt="User"
            style={{ width: "30%", height: "150px", objectFit: "contain" }}
          />
          <img
            src="https://firebasestorage.googleapis.com/v0/b/imagine-bc615.appspot.com/o/customers%2Fsignature%2F2025-01-14%2012%3A14%3A11?alt=media&token=9aea6407-c386-4f26-a958-7b1085f3dc16"
            alt="Signature"
            style={{ width: "30%", height: "150px", objectFit: "contain" }}
          />
        </div>
  
        <div style={{ marginTop: "16px" }}>
          <DetailRow label="Name" value="Emily" />
          <DetailRow label="Phone" value="123-456-7890" />
          <DetailRow label="Email" value="emily@example.com" />
          <DetailRow label="State" value="California" />
        </div>
  
        {/* Button */}
        <div style={{ textAlign: "center", marginTop: "24px" }}>
          <button
            style={{
              padding: "10px 20px",
              backgroundColor: "#007BFF",
              color: "#ffffff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "16px",
            }}
            onClick={() => alert("Button Clicked!")}
          >
            Confirm Details
          </button>
        </div>
      </div>
    );
  }
  
  function DetailRow({ label, value }) {
    return (
      <div
      className="text-black"
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "16px",
          
        }}
      >
        <span style={{ fontWeight: "bold" }}>{label}</span>
        <span>{value}</span>
      </div>
    );
  }